<template>
  <div>
    <collapsibleItem class="data-item mb8" v-if="!isRing">
      <p slot="heading">显示数目</p>
      <div slot="body" class="mt8">
        <el-radio-group v-model="dataLengthAuto">
          <el-radio label="all">全部展示</el-radio>
          <el-radio label="auto">自定义展示</el-radio>
        </el-radio-group>
        <div class="mt16 verticallyCenter borderRadius4" v-if="dataLengthAuto === 'auto'">
          <span class="font14 mr6 half-label">显示数量</span>
          <single-input
            class="percent65_"
            :value.sync="dataLength"
            inputSuffixs="条"
            placeholder="请输入"
            :min="1"
            :step="1"
          />
<!--          <el-input-->
<!--              class="percent65_"-->
<!--              v-model="dataLength"-->
<!--              placeholder="请输入"-->
<!--              :controls="false"-->
<!--              :min="1"-->
<!--              :step="1"-->
<!--              type="number"-->
<!--              v-inputHandle="{ this1, type: 'dataLength' }"-->
<!--          >-->
<!--            <template slot="suffix">-->
<!--              <span class="suffix_text">条</span>-->
<!--            </template>-->
<!--          </el-input>-->
        </div>
        <div class="mt16" v-if="!isRing && dataLengthAuto === 'auto' && !isStyle7">
          <cx-check-box :value.sync="autoScrollSet" class="">开启滚动</cx-check-box>
          <div class="color-container mt16 mb16" v-if="autoScrollSet">
            <!--类型-->
            <cx-select :value.sync="scrollType" :selectOptions="typeSelectOptions" title="类型" />
            <div class="data-item mt16" v-if="scrollType === 1">
              <cx-check-box :value.sync="showScrollBar" class="">开启滚动条</cx-check-box>
              <div class="mt16" v-if="showScrollBar">
                <p>滚动条样式设置</p>
                <div class="verticallyCenter mt16">
                  <label class="font14 mr8">填充颜色</label>
                  <div class="color-picker-container percent65_">
                    <el-color-picker
                        class=""
                        v-model="scrollBarBg"
                        color-format="rgb"
                        :show-alpha="true"
                        :predefine="predefineColors"
                    ></el-color-picker>
                    <span class="color-text overflowHid percent80">{{ scrollBarBg }}</span>
                  </div>
                </div>
                <div class="verticallyCenter mt16">
                  <label class="font14 mr8">边框颜色</label>
                  <div class="color-picker-container percent65_">
                    <el-color-picker
                        class=""
                        v-model="scrollBarBorderColor"
                        color-format="rgb"
                        :show-alpha="true"
                        :predefine="predefineColors"
                    ></el-color-picker>
                    <span class="color-text overflowHid percent80">{{ scrollBarBorderColor }}</span>
                  </div>
                </div>
                <div class="data-item mt16">
                  <p>宽度</p>
                  <slider-and-input
                      inputWidth="large"
                      inputHeight="small"
                      :value.sync="scrollBarWidth"
                      titlePosition="singleLine"
                      :sliderMax="100"
                      :suffix="chartOpt.yAxis.data.length > 0 ?'px':'%'"
                  />
                  <p>高度</p>
                  <slider-and-input
                      inputWidth="large"
                      inputHeight="small"
                      :value.sync="scrollBarHeight"
                      titlePosition="singleLine"
                      :sliderMax="100"
                      :suffix="chartOpt.yAxis.data.length > 0 ?'%':'px'"
                  />
                </div>
                <cx-check-box class="mt16" :value.sync="scrollPaddingAuto">边距自定义</cx-check-box>
                <div class="mt16 scrollbar-padding setting-item-grid home" v-if="scrollPaddingAuto">
                  <slider-and-input
                      :value.sync="scrollPaddingTop"
                      :sliderMax="100"
                      suffix="%"
                      className="grid_home edge_2"
                      inputWidth="small"
                      inputHeight="small"
                      tips="上边距"
                  />
                  <slider-and-input
                      :value.sync="scrollPaddingLeft"
                      :sliderMax="100"
                      suffix="%"
                      class="mt16"
                      className="grid_home edge_1"
                      inputWidth="small"
                      inputHeight="small"
                      tips="左边距"
                  />
                </div>
              </div>
            </div>
            <div class="data-item mt16" v-if="scrollType === 2">
              <p class="font14 mb8">自动滚动间隔时间</p>
              <slider-and-input
                  :value.sync="autoScrollTime"
                  :sliderMin="1"
                  :sliderMax="20"
                  suffix="秒"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    },
    isRing: {
      type: Boolean
    }
  },
  data() {
    return {
      this1: this,
      autoScrollTimeMax: 1,
      typeSelectOptions: [
        {
          label: "手动滚动",
          value: 1
        },
        {
          label: "自动滚动",
          value: 2
        }
      ],
      isStyle7: false
    }
  },
  computed: {
    chartOpt() {
      if (this.options.chartOption?.yAxis?.axisLabel?.rich) {
        this.isStyle7 = true
      }else{
        this.isStyle7 = false
      }
      return this.options.chartOption
    },
    // 动态数据
    seriesData() {
      return this.options.chartOption.series
    },
    // 柱状图是否开启滚动
    autoScrollSet: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.autoScrollSet", "dataZoomSet.autoScrollSet", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.autoScrollSet", false)
      }
    },
    autoScrollTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.autoScrollTime", "dataZoomSet.autoScrollTime", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.autoScrollTime", false)
      }
    },
    // 柱状图展示数目自定义
    dataLengthAuto:{
      get(){
        if(!this.chartOpt.dataZoomSet){
          this.$changeOptionsEV({}, "chartOption.dataZoomSet", false, false, false, true)
        }
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.dataLengthAuto", "dataZoomSet.dataLengthAuto", 'all')
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.dataLengthAuto", false)
      }
    },
    dataLength: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.dataLength", "dataZoomSet.dataLength", this.seriesData[0].data.length)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.dataLength", false)
      }
    },
    scrollType: {
      get(){
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollType", "dataZoomSet.scrollType", 1)
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollType", false)
      }
    },
    showScrollBar: {
      get(){
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.showScrollBar", "dataZoomSet.showScrollBar", false)
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.showScrollBar", false)
      }
    },
    scrollBarWidth: {
      get() {
        let data1 = 90
        if(this.chartOpt.yAxis.data.length > 0){
          data1 = 30
        }
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollBarWidth", "dataZoomSet.scrollBarWidth", data1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollBarWidth", false)
      }
    },
    scrollBarHeight: {
      get() {
        let data1 = 30
        if(this.chartOpt.yAxis.data.length > 0){
          data1 = 90
        }
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollBarHeight", "dataZoomSet.scrollBarHeight", data1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollBarHeight", false)
      }
    },
    scrollBarBg: {
      get() {
        return this.checkAndSetPrimaryVal(
            this.chartOpt,
            "dataZoomSet.scrollBarBg",
            "dataZoomSet.scrollBarBg",
            "rgba(47,69,84,0)"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollBarBg", false)
      }
    },
    scrollBarBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(
            this.chartOpt,
            "dataZoomSet.scrollBarBorderColor",
            "dataZoomSet.scrollBarBorderColor",
            "rgba(0,0,0,0)"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollBarBorderColor", false)
      }
    },
    scrollPaddingAuto: {
      get(){
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollPaddingAuto", "dataZoomSet.scrollPaddingAuto", false)
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollPaddingAuto", false)
      }
    },
    // 边距
    scrollPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollPaddingTop", "dataZoomSet.scrollPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollPaddingTop", false)
      }
    },
    scrollPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "dataZoomSet.scrollPaddingLeft", "dataZoomSet.scrollPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.dataZoomSet.scrollPaddingLeft", false)
      }
    },
  },
  mounted() {
    this.autoScrollTimeMax = this.options.chartOption.refreshTime / 1000
  },
  methods: {}
}
</script>

<style scoped>
  .percent65_ {
    width: calc(100% - 65px);
  }
  .bgGrey{
    background-color: var(--elCollapseItemHeaderBgColor);
  }
  .padding20{
    padding: 20px;
  }
  .padding16{
    padding: 16px;
  }
 .borderRadius4{
   border-radius: 4px;
 }
</style>
